"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMELINE_TABLE_KEYS = void 0;
var TIMELINE_TABLE_KEYS;
(function (TIMELINE_TABLE_KEYS) {
    TIMELINE_TABLE_KEYS["CHANGE_TYPE"] = "changeType";
    TIMELINE_TABLE_KEYS["DISPLAY_NAME"] = "displayName";
    TIMELINE_TABLE_KEYS["MODIFIED_BY"] = "modifiedBy";
    TIMELINE_TABLE_KEYS["NAME"] = "name";
    TIMELINE_TABLE_KEYS["SONAR_OBJECT_TYPE"] = "sonarObjectType";
    TIMELINE_TABLE_KEYS["TIMESTAMP"] = "timestamp";
})(TIMELINE_TABLE_KEYS || (exports.TIMELINE_TABLE_KEYS = TIMELINE_TABLE_KEYS = {}));
//# sourceMappingURL=TIMELINE_TABLE_KEYS.js.map